export interface Category {
  name: string;
  nameKey: string;
  url: string;
}

export const categories: Category[] = [
  { name: "Shoes", nameKey: "category_shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { name: "Hoodies/Sweaters", nameKey: "category_hoodies", url: "https://kaspreadsheet.com/search-912/name/Shoes.html" },
  { name: "T-Shirts", nameKey: "category_tshirts", url: "https://kaspreadsheet.com/search-913/name/Shoes.html" },
  { name: "Jackets", nameKey: "category_jackets", url: "https://kaspreadsheet.com/search-914/name/Shoes.html" },
  { name: "Pants/Shorts", nameKey: "category_pants", url: "https://kaspreadsheet.com/search-915/name/Shoes.html" },
  { name: "Headwear", nameKey: "category_headwear", url: "https://kaspreadsheet.com/search-916/name/Shoes.html" },
  { name: "Sets", nameKey: "category_sets", url: "https://kaspreadsheet.com/search-917/name/Shoes.html" },
  { name: "Underwear/Underpants", nameKey: "category_underwear", url: "https://kaspreadsheet.com/search-918/name/Shoes.html" },
  { name: "Jersey", nameKey: "category_jersey", url: "https://kaspreadsheet.com/search-919/name/Shoes.html" },
  { name: "Accessories", nameKey: "category_accessories", url: "https://kaspreadsheet.com/search-920/name/Shoes.html" },
  { name: "Bags", nameKey: "category_bags", url: "https://kaspreadsheet.com/search-921/name/Shoes.html" },
  { name: "Belts", nameKey: "category_belts", url: "https://kaspreadsheet.com/search-922/name/Shoes.html" },
  { name: "Perfumes", nameKey: "category_perfumes", url: "https://kaspreadsheet.com/search-923/name/Shoes.html" },
  { name: "Other Stuff", nameKey: "category_other", url: "https://kaspreadsheet.com/search-924/name/Shoes.html" },
];